import util from '../util'

let controller = 'CadastroFavorecidoLoteArquivo'
export default Object.assign({}, util.GetCrud(controller, null), {
    ImportarArquivo: function (dto) {
        return util.Axios.Post(controller + '/ImportarArquivo', dto)
    },
})
